// src/components/first/Dashboard.js
import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

const Dashboard = () => {
  return (
    <div className="dashboard-layout">
      <Header />
      <div className="dashboard-body" style={{ display: 'flex' }}>
        <Sidebar />
        <div
          className="main-content"
          style={{
            flex: 1,
            padding: '1rem',
            minHeight: '100vh', // Ensures child pages fill the height
            backgroundColor: '#f9f9f9', // Light background for child pages
          }}
        >
          <Outlet /> {/* All route children (MainContent, Temperature, etc.) render here */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
